<script setup lang="ts">
import { useAttrs, useSlots } from 'vue';
defineOptions({ inheritAttrs: false, name: 'EGS_Divider' });
withDefaults(defineProps<{ layout?: 'horizontal' | 'vertical'; type?: string; align?: string }>(), { layout: 'horizontal', type: 'solid', align: 'center' });
const attrs = useAttrs();
const slots = useSlots();
</script>
<template>
	<div
		v-bind="attrs"
		:class="[layout === 'vertical' ? 'mx-3 min-h-full w-px self-stretch border-l border-surface' : 'my-4 flex h-px w-full items-center border-t border-surface', type === 'dashed' ? 'border-dashed' : '', attrs['class']]"
		role="separator"
	>
		<span v-if="slots['default']" class="bg-[var(--egs-content-background)] px-2 text-color-secondary"><slot /></span>
	</div>
</template>
